// Modules.
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

// Components.
import Header from './Header';

// Store.
const mapStateToProps = state => ({
    gvars: state.global.gvars,
    primary: state.menu.primary,
});

export default withRouter(
    connect(mapStateToProps)(Header)
);
